import { render, staticRenderFns } from "./createContact.vue?vue&type=template&id=4a8e435f&scoped=true&"
import script from "./createContact.vue?vue&type=script&lang=js&"
export * from "./createContact.vue?vue&type=script&lang=js&"
import style0 from "./createContact.vue?vue&type=style&index=0&id=4a8e435f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e435f",
  null
  
)

export default component.exports